/* eslint-disable */
import React, { PropsWithChildren } from "react";
import ReactDOM from "react-dom";
import IconButton from "@mui/material/IconButton";
import HelpIcon from "@mui/icons-material/Help";
import { Menu, MenuItem } from "@mui/material";
import { DocumentationIcon } from "./sidebar/DocumentationIcon";
import DiscordLogo from "./upsolver-images/logos/Discord-Logo-Black.svg";
import withStyles from "@mui/styles/withStyles";

const SupportMenuButton = withStyles({
  root: {
    position: "fixed",
    zIndex: 1,
    backgroundColor: "#1cade4",
    bottom: "1.75em",
    right: ".875em",
    "& svg": {
      width: "1.75em",
      height: "1.75em",
      color: "#fff",
    },
    "&:hover": {
      backgroundColor: "#1cade4b3",
    },
  },
})(IconButton);

const SupportMenuItem = withStyles({
  root: {
    display: "flex",
    alignItems: "center",
    paddingTop: 10,
    paddingBottom: 10,
    "& svg, img": {
      width: "1.75em",
      marginRight: ".75em",
      "& path": {
        fill: "#9f9f9f",
      },
    },
  },
})(({ classes, linkTo, children }: PropsWithChildren<any>) => (
  <MenuItem classes={classes} component="a" href={linkTo} target="_blank">
    {children}
  </MenuItem>
));

export default function CommunitySupportMenu() {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return ReactDOM.createPortal(
    <>
      <SupportMenuButton onClick={handleClick}>
        <HelpIcon />
      </SupportMenuButton>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <SupportMenuItem linkTo={"https://docs.upsolver.com/upsolver-1/"}>
          {DocumentationIcon}
          <span>Read our documentation</span>
        </SupportMenuItem>

        <SupportMenuItem linkTo={"https://discord.gg/uCg74f3fJH"}>
          <img src={DiscordLogo} alt="Discord-Logo" />
          <span>Go to Upsolver Community</span>
        </SupportMenuItem>
      </Menu>
    </>,
    document.body
  );
}
